import service from './api.services';

const buscarUsuario = async () => {
    const response = await service.get('/api/autenticacao/eu');
    return response.data;
};

const solicitarToken = async () => {
    const response = await service.get('/api/autenticacao/solicitar-token');
    return response;
};

export {
    buscarUsuario,
    solicitarToken
};
